/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Precondition Failed - Resource. Problem schema.
 */
export interface ProblemResourcePreconditionFailed {
    /**
     * The general purpose ETag.
     * The essential field for **optimistic concurrency**.
     * - [Zalando RESTful Guidelines / Appendix C: Best practices / ETags in result entities](https://opensource.zalando.com/restful-api-guidelines/#ETag-in-result-entities)
     * - [RFC 9110 - 8.8.3 ETag](https://www.rfc-editor.org/rfc/rfc9110.html#name-ETag)
     * - [RFC 9110 - 13.1.1. IfMatch](https://www.rfc-editor.org/rfc/rfc9110.html#name-if-match)
     * - [RFC 9110 - 13.1.2. IfNoneMatch](https://www.rfc-editor.org/rfc/rfc9110.html#name-if-none-match)
     * - [Kubernetes' Concurrency Control and Consistency](https://github.com/kubernetes/community/blob/master/contributors/devel/sig-architecture/api-conventions.md#concurrency-control-and-consistency).
     */
    actual: string;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string;
    /** Optional list of individual error details */
    errors?: Truvity.ErrorDetail[];
    expected: Truvity.Resource;
    /** A URI reference that identifies the specific occurrence of the problem. */
    instance?: string;
    /** HTTP status code */
    status: number;
    /** This value should not change between occurrences of the error. */
    title: string;
}
